import bookingTemplate from "./booking";
import paymentTemplate from "./payment";

const loadingTemplates = {
  booking: bookingTemplate,
  payment: paymentTemplate
}

function makeLoadingSkeleton(loadingTemplate) {
  const bookingPreviewModal = $('#bookingPreviewModal');
  const loadingWrapper = bookingPreviewModal.find("#loadingWrapper");
  const loadingPreventClick = $('<div id="loadingPreventClick"></div>');

  loadingWrapper.empty();
  loadingWrapper.append(loadingPreventClick);

  if(!(loadingTemplate in loadingTemplates)) loadingTemplate = "booking";
  loadingTemplates[loadingTemplate]().insertBefore(loadingPreventClick);
}

export default makeLoadingSkeleton;